// Originally sourced from https://stackoverflow.com/a/11196395
class PauseableInterval {
  constructor(callback, delay) {
    this.callback = callback
    this.delay = delay
    this.pausedTimeLeft = 0
    this.timerIsPaused = false
    this.timerHasPaused = false
    this.triggerSetAt = new Date().getTime()
    this.timer = setInterval(this.callback, this.delay)
  }

  reset() {
    this.#clearTimer()

    this.pausedTimeLeft = 0
    this.timerIsPaused = false
    this.timerHasPaused = false
    this.triggerSetAt = new Date().getTime()

    this.timer = setInterval(this.callback, this.delay)
  }

  #getTimeLeft() {
    const now = new Date()
    const timeLeft = this.timerHasPaused ? this.pausedTimeLeft : this.delay

    // Once a timer has been paused the remaining amount of time left
    // needs to be calculated from the paused time left.
    return timeLeft - ((now - this.triggerSetAt) % this.delay)
  }

  pause() {
    this.pausedTimeLeft = this.#getTimeLeft()
    this.timerIsPaused = true
    this.timerHasPaused = true
    this.#clearTimer()
  }

  resume() {
    // A new trigger is set based on unpaused. PauseTimeLeft is used
    // as the setTimeout timer.
    this.triggerSetAt = new Date().getTime()

    this.timer = setTimeout(() => {
      this.callback()
      this.reset()
    }, this.pausedTimeLeft)
  }

  #clearTimer() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  isPaused() {
    return this.timerIsPaused
  }
}

export default PauseableInterval
